import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoginComponentComponent } from "./login-component/login-component.component";
import { PaymentInitiateComponent } from "./payment/payment-initiate/payment-initiate.component";

import { RefundRequestComponent } from "./refund/refund-request/refund-request.component";
import { RefundApprovedComponent } from "./refund/refund-approved/refund-approved.component";
import { RefundInitiateComponent } from "./refund/refund-initiate/refund-initiate.component";
import { RefundSuccessComponent } from "./refund/refund-success/refund-success.component";
import { RefundFailedComponent } from "./refund/refund-failed/refund-failed.component";
import { AuthGardService } from "./services/auth-gard.service";
import { PaymentDetailsComponent } from "./payment/payment-initiate/payment-details/payment-details.component";
import { PaymentNROComponent } from "./payment/payment-nro/payment-nro.component";
import { PayementBlockerComponent } from "./payement-blocker/payement-blocker.component";

const routes: Routes = [
  { path: "", redirectTo: "Login", pathMatch: "full" },
  { path: "Login", component: LoginComponentComponent },
  {
    path: "Refund-request",
    component: RefundRequestComponent,
    canActivate: [AuthGardService],
  },
  {
    path: "Payment-Initiate",
    component: PaymentInitiateComponent,
    canActivate: [AuthGardService],
  },
  {
    path: "Payment-NRO",
    component: PaymentNROComponent,
    canActivate: [AuthGardService],
  },

  {
    path: "Refund-request",
    component: RefundRequestComponent,
    canActivate: [AuthGardService],
  },
  {
    path: "Refund-approved",
    component: RefundApprovedComponent,
    canActivate: [AuthGardService],
  },
  {
    path: "Refund-initiated",
    component: RefundInitiateComponent,
    canActivate: [AuthGardService],
  },
  {
    path: "Refund-success",
    component: RefundSuccessComponent,
    canActivate: [AuthGardService],
  },
  {
    path: "Refund-failed",
    component: RefundFailedComponent,
    canActivate: [AuthGardService],
  },
  {
    path: "Refund-failed",
    component: RefundFailedComponent,
    canActivate: [AuthGardService],
  },
  {
    path: "payment-blocker",
    component: PayementBlockerComponent,
    canActivate: [AuthGardService],
  },
  { path: "**", redirectTo: "Login", pathMatch: "full" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
